<template>
  <DelDialog
    width="480px"
    :dialogVisible="visible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('newProjectV2.editPunctuateRule')}}</template>
    <el-form :rules="rules" ref="form" :model="form">

      <!-- <el-form-item :label="$t('newProjectV2.punctuateType')">
          <el-radio-group v-model="form.type" :disabled="true">
            <el-radio label="0">{{$t('newProjectV2.configPunctuateRule')}}</el-radio>
            <el-radio label="1">{{$t('newProjectV2.uploadPunctuateRule')}}</el-radio>
          </el-radio-group>
        </el-form-item> -->

      <el-form-item :label="$t('newProjectV2.name')" prop="ruleName">
        <el-input
          maxlength="8"
          v-model.trim="form.ruleName"
          :placeholder="$t('newProjectV2.punctuateRuleNameTip')"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item :label="$t('newProjectV2.language')" prop="langCode">
        <el-select v-model="form.langCode" :placeholder="$t('newProjectV2.punctuateRuleLangTip')" :disabled="true">
          <el-option
            v-for="item in language"
            :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
            :value="item.code"
            :key="item.code"
          >
          </el-option>
      </el-select>
      </el-form-item> -->

    </el-form>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import {
  // queryAllLang,
  updateRuleName
} from '@/services/dialogApi';

export default {
  name: 'editPunctuateRules',
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    editRule: {
      type: Object,
      require: true,
    }
  },
  components: {
    DelDialog
  },
  data () {
    return {
      rules: {
        ruleName: [
          { required: true, message: this.$t('newProjectV2.punctuateRuleNameTip'), trigger: 'blur' }
        ]
      },
      form: {
        ruleName: '',
        // type: '',
        // langCode: ''
      },
      language: []
    }
  },
  watch: {
    editRule: {
      handler (newVal) {
        this.form.ruleName = newVal.ruleName;
        // this.form.type = newVal.type.toString();
        // this.form.langCode = newVal.langCode;
      },
      deep: true,
    }
  },
  methods: {
    handleCancel () {
      this.$refs.form.clearValidate();
      this.$emit('handleCancel');
    },
    handleConfirm () {
      let self = this;
      self.$refs['form'].validate((valid) => {
        if (valid) {

          let param = {
            id: self.editRule.id,
            ruleName: self.form.ruleName
          }

          updateRuleName(param).then(resp => {
            if (resp.success) {
              self.$message.closeAll();
              self.$message({
                message: self.$t('newProjectV2.updateSuccess'),
                type: "success"
              });
              self.handleCancel();
              self.$emit('updateRule');
            }
          });
        }
      });
    },
    // getLanguage () {
    //   const self = this;
    //   queryAllLang({}).then((resp) => {
    //     if (resp.success) {
    //       self.language = resp.result;
    //     }
    //   });
    // },
  },
  created () {
    // this.getLanguage();
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>